const events = require('../scripts/events')
const moment = require('moment')
const { uuid } = require('uuidv4')

module.exports = {
  nuxtServerInit: async ({ commit, state }, context) => {
    const states = await context.store.$backend.locations()
    const globals = await state.globals
    commit('locations/setAllLocations', states)
    if (process.env.GW_ID_CATERING) {
      const cateringStates = await context.store.$backend.locations('catering')
      commit('locations/setCateringLocations', cateringStates)
    }
    try {
      let siteBanner = await context.store.$utils.content('_globals/site-banner')
      globals.siteBanner = siteBanner
    } catch (err) {
      // maybe it's not published
    }

    try {
      let welcomePopup = await context.store.$utils.content('_globals/welcome-popup')
      globals.welcomePopup = welcomePopup.content
    } catch(err) {
      // maybe it's not published
    }

    commit('setGlobals', globals)
  },
  nuxtClientInit: async ({ commit, state }, context) => {
    if (context.$recaptcha) {
      context.$recaptcha.init()
    }

    try {
      localStorage.setItem(`site_load`, true)
      const localDeviceId = localStorage.getItem(`${process.env.APP_PREFIX}_deviceId`)

      if (localDeviceId) {
        commit('setDeviceId', localDeviceId)
      } else {
        const deviceId = uuid()
        commit('setDeviceId', deviceId)
        localStorage.setItem(`${process.env.APP_PREFIX}_deviceId`, deviceId)
      }

      if (localStorage.getItem(`${process.env.APP_PREFIX}_channel`)) {
        try {
          commit('setChannel', localStorage.getItem(`${process.env.APP_PREFIX}_channel`))
        } catch (err) {
          localStorage.setItem(`${process.env.APP_PREFIX}_channel`, 'default')
        }
      }

      if (localStorage.getItem(`${process.env.APP_PREFIX}_userChannel`)) {
        try {
          commit('setUserChannel', localStorage.getItem(`${process.env.APP_PREFIX}_userChannel`))
        } catch (err) {
          localStorage.setItem(`${process.env.APP_PREFIX}_userChannel`, 'US')
        }
      }

      if (localStorage.getItem(`${process.env.APP_PREFIX}_appState`)) {
        try {
          commit('setAppState', JSON.parse(localStorage.getItem(`${process.env.APP_PREFIX}_appState`)))
        } catch (err) {
          localStorage.removeItem(`${process.env.APP_PREFIX}_appState`)
        }
      }
      if (localStorage.getItem(`${process.env.APP_PREFIX}_location`)) {
        try {
          commit('setLocation', JSON.parse(localStorage.getItem(`${process.env.APP_PREFIX}_location`)))
        } catch (err) {
          localStorage.removeItem(`${process.env.APP_PREFIX}_location`)
        }
      }
      if (localStorage.getItem(`${process.env.APP_PREFIX}_token`)) {
        try {
          commit('setToken', JSON.parse(localStorage.getItem(`${process.env.APP_PREFIX}_token`)))
        } catch (err) {
          localStorage.removeItem(`${process.env.APP_PREFIX}_token`)
        }
      }
      if (localStorage.getItem(`${process.env.APP_PREFIX}_user`)) {
        try {
          commit('setUser', JSON.parse(localStorage.getItem(`${process.env.APP_PREFIX}_user`)))
        } catch (err) {
          localStorage.removeItem(`${process.env.APP_PREFIX}_user`)
        }
      }
      if (localStorage.getItem(`${process.env.APP_PREFIX}_cart`)) {
        try {
          commit('setCart', JSON.parse(localStorage.getItem(`${process.env.APP_PREFIX}_cart`)))
        } catch (err) {
          localStorage.removeItem(`${process.env.APP_PREFIX}_cart`)
        }
      }
      if (localStorage.getItem(`${process.env.APP_PREFIX}_menu`)) {
        try {
          commit('setMenu', JSON.parse(localStorage.getItem(`${process.env.APP_PREFIX}_menu`)))
        } catch (err) {
          localStorage.removeItem(`${process.env.APP_PREFIX}_menu`)
        }
      }
      if (localStorage.getItem(`${process.env.APP_PREFIX}_group_order`)) {
        try {
          commit('setGroupOrder', JSON.parse(localStorage.getItem(`${process.env.APP_PREFIX}_group_order`)))
        } catch (err) {
          localStorage.removeItem(`${process.env.APP_PREFIX}_group_order`)
        }
      }
      if (localStorage.getItem(`${process.env.APP_PREFIX}_tableposref`)) {
        try {
          commit('locations/setTableposref', JSON.parse(localStorage.getItem(`${process.env.APP_PREFIX}_tableposref`)))
        } catch (err) {
          localStorage.removeItem(`${process.env.APP_PREFIX}_tableposref`)
        }
      }
      localStorage.removeItem(`site_load`)
    } catch (err) {
      console.error('An error occurred while accessing localStorage:', error)
    }

    const storyblokAsapDisabled = (state.appInfo.disabled_features && state.appInfo.disabled_features.storyblok_asap_unavailable) || false
    if (!storyblokAsapDisabled) {
      // get asap unavailable message from storyblok
      const globalAsapUnavailable = await context.store.$utils.content('_globals/asap-unavailable')
      if (globalAsapUnavailable) {
        const sections = globalAsapUnavailable.content.sections || []
        const sectionFound = sections.find(section => section.component === 'asap-unavailable-message')
        if (sectionFound) {
          commit('order/setAsapUnavailable', sectionFound, { root: true })
        }
      }
    }
  },
  sendRequest: async ({ state }, config) => {
    config.url = `v2/${config.url.replace(/^\//, '')}`
    if (!config.headers) {
      config.headers = {}
    }
    if (config.headers.verify && $nuxt.$store.$recaptcha) {
      config.headers.verify = await $nuxt.$store.$recaptcha.execute('login')
    }
    if (process.env.GW_ENV) {
      config.headers.env = process.env.GW_ENV
    }
    if (state.channel !== 'default') {
      config.headers.client_sub = state.channel
    }
    if (state.appState) {
      if (state.appState.client_type) {
        config.headers.client_type = state.appState.client_type
      }
      if (state.appState.device_id) {
        config.headers.device_id = state.appState.device_id
      }
      if (state.appState.push_token) {
        config.headers.push_token = state.appState.push_token
      }
    }
    if (state.token) {
      config.headers.token = state.token.value
    }
    if (state.deviceId && !config.headers.device_id) {
      config.headers.device_id = state.deviceId
    }

    return await $nuxt.$store
      .$axios(config)
      .then(res => {
        if (res.status === 202) {
          return {
            status: 'validate',
            data: res.data,
          }
        } else if(res.status === 204) {
          return {
            status: 'deleted',
            data: null,
          }
        } else {
          return {
            status: 'ok',
            data: res.data,
          }
        }
      })
      .catch(err => {
        if (!err.response) {
          return {
            status: 'error',
            message: 'We’re having trouble connecting you to our platform. Please ensure your internet connection is stable & secure before trying again.',
          }
        }

        // Thanx error response
        if (err.response.status === 400 && err.response.data.error && err.response.data.error.code === 'BAD_REQUEST' && err.response.data.error.message) {
          return {
            status: 'error',
            message: err.response.data.error.message,
          }
        }

        if (err.response.status === 401 && config.data && config.data.provider === 'thanx') {
          return err.response.data
        }

        // TODO: redirect to signup?
        if (err.response.status === 401) {
          return {
            status: 'error',
            message: 'Unauthorized',
          }
        }

        if (!err.response.data) {
          return {
            status: 'error',
            message: 'We’re having trouble connecting you to our platform. Please ensure your internet connection is stable & secure before trying again.',
          }
        }

        return {
          status: 'error',
          message: err.response.data.message,
          errors: err.response.data.errors,
        }
      })
  },
  getAppState: async ({ state, commit, dispatch }, route) => {
    let appState = null
    /*if(route.params.id) {
      const config = {
        method: 'get',
        url: 'members/auth',
        params: {
          state: route.params.id
        }
      }
      const response = await dispatch('sendRequest', config)
      if(response.status === 'ok') {
        appState = response.data
      }
    } else*/ if (route.query) {
      appState = route.query
    }
    commit('setAppState', appState)
    return true
  },
  resetMenu: async ({ state, commit, dispatch }, id) => {
    const locConfig = {
      method: 'get',
      url: `locations/${id}`,
      params: {
        byMenuId: true,
      },
    }
    const locResponse = await dispatch('sendRequest', locConfig)
    if (locResponse.status !== 'ok') {
      return false
    }
    commit('setLocation', locResponse.data)
    if (locResponse.services && locResponse.services.transfercart && state.cart && state.cart.menu_id !== locResponse.data.menu_id) {
      await dispatch('transferCart', locResponse.data.menu_id)
    } else {
      await dispatch('abandonCart')
    }
    const menuConfig = {
      method: 'get',
      url: `menus/${id}`,
    }
    const menuResponse = await dispatch('sendRequest', menuConfig)
    if (menuResponse.status !== 'ok') {
      return false
    }
    dispatch('separateMenus', menuResponse.data)
    return true
  },
  reloadLocation: async ({ commit, dispatch }, id) => {
    const locConfig = {
      method: 'get',
      url: `locations/${id}`,
      params: { byMenuId: true },
    }
    const locResponse = await dispatch('sendRequest', locConfig)
    if (locResponse.status !== 'ok') {
      return false
    }
    commit('setLocation', locResponse.data)
    return true
  },

  changeLocation: ({ state, commit, dispatch }, location = null) => {
    if (state && state.cart && state.cart.products && state.cart.products.length === 0) {
      commit('setLocation', location)
      return false
    } else if (state && state.location && state.location.services && state.location.services.transfercart === false) {
      const message = {
        message: `
          Changing your location will clear your cart. 
          Do you want to continue?
        `,
        actions: [
          {
            type: 'button',
            title: 'Change location anyway',
            class: 'primary',
            callback: async () => {
              await dispatch('abandonCart')
              commit('setLocation', location)
              return false
            },
          },
          {
            type: 'button',
            callback: () => {
              return false
            },
            title: 'Cancel',
            class: 'neutral',
          },
        ],
      }
      commit('setErrors', message)
      return false
    } else if (state && state.cart && location && location.menu_id && state.cart.menu_id !== location.menu_id) {
      dispatch('transferCart', location.menu_id)
      commit('setLocation', location)
      return false
    } else {
      commit('setLocation', location)
      return false
    }
  },

  createCart: async ({ state, commit, dispatch, rootState }) => {
    if (state.location && !state.cart) {
      const cartConfig = {
        method: 'post',
        url: `carts`,
        data: {
          menu_id: state.location.menu_id,
        },
      }
      const cartResponse = await dispatch('sendRequest', cartConfig)
      if (cartResponse.status !== 'ok') {
        // TODO: Handle error
        return false
      }
      cartResponse.data.type = 'mealtime'
      commit('setCart', cartResponse.data)
      if (cartResponse.data.token) {
        commit('setToken', cartResponse.data.token)
      }
      let tracking = state.appInfo.library_tracking === false || state.appInfo.library_tracking === true ? state.appInfo.library_tracking : true
      events.pushEvent('begin_order', cartResponse.data, window, state.location, cartResponse.data, state.user, tracking, rootState.menu, rootState.channel)
      return true
    }
    return false
  },
  getCart: async ({ state, commit, dispatch }) => {
    if (state.cart && state.cart.id) {
      const cartConfig = {
        method: 'get',
        url: `carts/${state.cart.id}`,
      }
      const cartResponse = await dispatch('sendRequest', cartConfig)
      if (cartResponse.status !== 'ok') {
        commit('setCart', null)
        return false
      }
      cartResponse.data.type = state.channel && state.channel !== 'default' ? state.channel : 'mealtime'
      commit('setCart', cartResponse.data)
      return true
    }
    return false
  },
  abandonCart: async ({ state, commit, dispatch }) => {
    if (state.cart) {
      const config = {
        method: 'delete',
        url: `carts/${state.cart.id}`,
      }
      await dispatch('sendRequest', config)
      commit('setCart', null)
      return true
    }
    return false
  },
  transferCart: async ({ state, commit, dispatch }, menuId) => {
    if (state.cart) {
      commit('setLoading', true)

      let headers = null
      if (state.channel === 'catering') {
        headers = {
          client_sub: 'catering',
        }
      }

      const config = {
        method: 'put',
        url: `carts/${state.cart.id}`,
        data: { menu_id: menuId },
        headers,
      }

      const response = await dispatch('sendRequest', config)
      if (response.status !== 'ok') {
        commit('setLoading', false, { root: true })
        console.log(response.message)
        commit('setErrors', 'We were not able to transfer your Cart.')
        await dispatch('abandonCart')
        return false
      } else {
        response.data.type = state.channel !== 'default' ? 'mealtime' : 'catering'
        await commit('setCart', response.data)
      }

      await dispatch('getCart', state.cart.id)
      commit('setLoading', false)
      return true
    }
    return 'no cart'
  },
  viewCart: ({ commit, state, rootState }, cart) => {
    let tracking = state.appInfo.library_tracking === false || state.appInfo.library_tracking === true ? state.appInfo.library_tracking : true
    events.pushEvent('view_cart', cart, window, state.location, state.cart, state.user, tracking, rootState.menu, rootState.channel)

    if (state.cart && state.cart.time && state.cart.time.mode) {
      const data = state.cart.time.mode === 'asap' ? moment(state.cart.time.earliest, 'YYYYMMDD HH:mm').format('MM-DD-YYYY HH:mm') : moment(state.cart.time.wanted, 'YYYYMMDD HH:mm').format('MM-DD-YYYY HH:mm')
      events.pushEvent('view_estimated_ready', data, window, state.location, state.cart, state.user, tracking, rootState.menu, rootState.channel)
    }

    commit('setShowCart', true)
  },
  hideCart: ({ commit }) => {
    commit('setShowCart', false)
  },
  selfUpsellsView: ({ commit }, status) => {
    commit('setIsUpsellsView', status)
  },
  selfUpsellsModalView: ({ commit }, status) => {
    commit('setIsUpsellsModalView', status)
  },
  // Spendgo Specific
  lookupUser: async ({ dispatch }, data) => {
    const config = {
      method: 'post',
      url: 'members/lookup',
      headers: {
        verify: true,
      },
      data,
    }
    const response = await dispatch('sendRequest', config)
    if (response.status !== 'ok') {
      return null
    } else {
      return response.data
    }
  },
  getUser: async ({ commit, dispatch }) => {
    const config = {
      method: 'get',
      url: 'members',
    }
    const response = await dispatch('sendRequest', config)
    if (response.status !== 'ok') {
      return false
    }
    commit('setUser', response.data)
    return true
  },
  getOrderHistory: async ({ rootState, commit, dispatch }) => {
    if (rootState.user) {
      const config = {
        method: 'get',
        url: 'orders',
      }
      const response = await dispatch('sendRequest', config)
      if (response.status !== 'ok') {
        return false
      }
      commit('setOrderHistory', response.data)
      return true
    }
  },
  clearUserData({ commit }) {
    // Clears all user data from the store
    commit('members/setRewards', null, { root: true })
    commit('checkout/setRewards', null, { root: true })
    commit('setRewards', null)
    commit('setCart', null)
    commit('setGroupOrder', null)
    commit('setUser', null)
    commit('setToken', null)
  },
  logoutUser: async ({ commit, dispatch }) => {
    
    commit('setLoading', true)
    
    await dispatch('sendRequest', {
      method: 'delete',
      url: 'members/auth',
    })
    
    // it doesn't matter if this request fails or not
    // the user wants to be logged out
    dispatch('clearUserData')
    
    commit('setLoading', false)
    return true
  },
  separateMenus: ({ commit }, menuData) => {
    // separate the catering categories from the standard menu categories
    const categories = [...menuData.categories]

    for (let i = 0; i < categories.length; i++) {
      categories[i].id = categories[i].id || i
    }

    const standardCategories = categories.filter(category => {
      const superCategory = category['super-category'] || ''
      return superCategory === '' || superCategory.toLowerCase().includes('standard')
    })

    const cateringCategories = categories.filter(category => {
      const superCategory = category['super-category'] || ''
      return superCategory.toLowerCase().includes('catering')
    })

    if (cateringCategories.length > 0) {
      commit('catering/setCateringMenu', cateringCategories, { root: true })
    }

    menuData.categories = [...standardCategories]
    commit('setMenu', menuData)
    commit('setSearchedMenu', false)
    commit('setFilteredMenu', [])
  },
  getDeliveryLocations: async ({ rootState, commit, dispatch }, payload) => {
    commit('setLoading', true)

    const data = {}
    if (payload.address) {
      data.address = payload.address
    }
    if (payload.city) {
      data.city = payload.city
    }
    if (payload.zip) {
      data.zip = payload.zip
    }
    if (payload.time) {
      data.time = payload.time
    }
    if (payload.lat) {
      data.lat = payload.lat
    }
    if (payload.lng) {
      data.lng = payload.lng
    }

    const config = {
      method: 'post',
      url: 'locations',
      data,
    }

    const response = await dispatch('sendRequest', config)

    if (response.status === 'ok') {
      if (rootState.cart && rootState.cart.menu_id !== response.data.menu_id) {
        const location = response.data
        if (location.services.transfercart) {
          await dispatch('transferCart', response.data.menu_id)
        }
      }
      commit('setLocation', response.data)
      commit('setLoading', false)
      return response.data
    } else {
      let messages = []
      if (typeof response.message === 'string') {
        messages.push(response.message)
      } else if (Array.isArray(response.message)) {
        messages = [...response.message]
      } else {
        messages = response.message
      }
      commit('setErrors', messages)
      commit('setLoading', false)
      return null
    }
  },
  filterMenu: ({ rootState, state, commit }, payload) => {
    const { searchTerm, placement, lifeStyleFilters, dietaryFilters } = payload
    let categories = []

    if (placement === 'menu') {
      categories = [...state.menu.categories]
    } else if (placement === 'catering') {
      categories = [...rootState.catering.cateringMenu]
    }
    if (!categories || categories.length === 0) {
      commit('setFilteredMenu', [])
      return
    }

    const search = searchTerm ? searchTerm.toLowerCase() : ''
    categories = categories.map(cat => {
      // If the category name matches the search, return the full category without filtering the products
      if (search && cat.name && cat.name.toLowerCase().includes(search)) {
        return cat
      }

      // To search by category description, add the "search_by_category_description" flag as "true" to the app.json file
      if (rootState.appInfo.search_by_category_description && cat.description && cat.description.toLowerCase().includes(search)) {
        return cat
      }

      // If the category name doesn't match the search, return all products that match the search or dietary filters
      const copiedCategory = { ...cat }

      if (copiedCategory.products && copiedCategory.products.length > 0) {
        copiedCategory.products = copiedCategory.products.filter(product => {
          const productNameMatch = product.name && product.name.toLowerCase().includes(search)
          const productDescriptionMatch = product.description && product.description.toLowerCase().includes(search)

          const correctedNutritionLifestyle = (product.nutrition_lifestyle || product['nutrition_lifestyle '] || '').trim()
          const correctedNutritionContains = (product.nutrition_contains || product['nutrition_contains'] || '').trim()

          const lifeStyleFilterMatch = lifeStyleFilters
            ? lifeStyleFilters.every(filter => {
                const nutritionLifestyle = correctedNutritionLifestyle ? correctedNutritionLifestyle.split(',').map(lifestyle => lifestyle.trim().toLowerCase()) : []
                return nutritionLifestyle.includes(filter.toLowerCase())
              })
            : true

          const dietaryFilterMatch = dietaryFilters
            ? dietaryFilters.every(filter => {
                const nutritionContains = correctedNutritionContains ? correctedNutritionContains.split(',').map(item => item.trim().toLowerCase()) : []
                return !nutritionContains.includes(filter.toLowerCase())
              })
            : true

          return (productNameMatch || productDescriptionMatch) && lifeStyleFilterMatch && dietaryFilterMatch
        })
      }

      return copiedCategory
    })

    // Hide categories that don't have any products after filtering
    categories = categories.filter(cat => {
      return cat.products.length > 0
    })

    commit('setSearchedMenu', true)
    commit('setFilteredMenu', categories)
  },

  trackEvent({ state, rootState }, payload) {
    // console.log(state.appInfo.client_analytic_tracking)
    const { name, data, windowObject } = payload
    if (!name || !windowObject) return
    let tracking = state.appInfo.library_tracking === false || state.appInfo.library_tracking === true ? state.appInfo.library_tracking : true
    events.pushEvent(name, data, windowObject, state.location, state.cart, state.user, tracking, state.menu, rootState.channel)
  },
  dumpAppData({ state, commit }) {
    // TODO: remove this log
    console.log('** App', state.checkout.placement)
    if (state && state.checkout && state.checkout.placement === 'app') {
      commit('setToken', null)
      commit('setAppState', null)
      commit('setUser', null)
      commit('setCart', null)
    }
  },
}
